import TransactionsIcon from "@/components/icons/TransactionsIcon.vue";
import DashboardIcon from "@/components/icons/DashboardIcon.vue";
import DepositIcon from "@/components/icons/DepositIcon.vue";
import BankIcon from "@/components/icons/BankIcon.vue";
import DisputeIcon from "@/components/icons/DisputeIcon.vue";
import DownloadsIcon from "@/components/icons/DownloadsIcon.vue";
import NotificationsIcon from "@/components/icons/NotificationsIcon.vue";
import PersonIcon from "@/components/icons/PaymentProfileIcon.vue";
import FlagIcon from "@/components/icons/FlagIcon.vue";

export const SidebarNavOptions = [
    {
        name: "setup_progress",
        icon: FlagIcon,
        route: "setup_progress"
    },
    {
        name: "dashboard",
        icon: DashboardIcon,
        route: "dashboard"
    },
    {
        name: "transactions",
        icon: TransactionsIcon,
        child:
            [
                {
                    parent: "transactions",
                    name: "payments",
                    route: "transactions",
                    childRoutes: ["transaction_details"]
                },
                {
                    parent: "transactions",
                    name: "authorizations",
                    route: "authorizations",
                    childRoutes: ["authorization_details"]
                }
            ]
    },
    {
      name: "balance_reserve",
      icon: BankIcon,
      route: "balance_reserve",
    },
    {
        name: "deposits",
        icon: DepositIcon,
        route: "deposits",
        childRoutes: ["deposit_details"]
    },
    {
        name: "disputes",
        icon: DisputeIcon,
        route: "disputes",
        childRoutes: ["dispute_details"]
    },
    {
        name: "downloads",
        icon: DownloadsIcon,
        child:
            [
                {
                    parent: "downloads",
                    name: "reports",
                    route: "reports",
                },
                {
                    parent: "downloads",
                    name: "exports",
                    route: "exports",
                },
                {
                    parent: "downloads",
                    name: "invoices",
                    route: "invoices",
                }
            ]
    },
    {
        name: "notifications",
        icon: NotificationsIcon,
        route: "notifications"
    },
    {
        name: "profile",
        icon: PersonIcon,
        route: "profile",
        childRoutes: ["compliance_form_details"]
    }
]